export const milePluralMapping = {
  '=0': '0 miles',
  '=1': '1 mile',
  other: '# miles',
};
